import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Navbar,
  Row
} from 'react-bootstrap';
import bg37 from 'assets/img/bg/building.jpg';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import Logo from 'components/common/Logo';
import Homepage from 'LandingPage/Homepage';
import { useAppContext } from 'providers/AppProvider';
import logo1 from 'assets/img/brand/pro.png';
import './style.css'

import { useBreakpoints } from 'providers/BreakpointsProvider';

interface AuthCardLayoutProps {
  logo?: boolean;
  className?: string;
}

const AuthCardLayout = ({
  logo = true,
  className,
  children
}: PropsWithChildren<AuthCardLayoutProps>) => {
  const {
    config: { isNavbarVerticalCollapsed }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();
  return (
    <>
      <Navbar
        expand="lg"
        className="custom-navbar bg-opacity-75 text-white fixed-top "
      >
        <Container fluid>
          <div className="d-flex align-items-center">
            {breakpoints.up('xs') &&
            breakpoints.down('sm') &&
            breakpoints.down('lg') &&
            breakpoints.down('md') ? null : (
              <Link to="/">
                <img src={logo1} alt="phoenix" width={80} />
              </Link>
            )}

            {!isNavbarVerticalCollapsed && (
              <Navbar.Brand as={Link} to="/" className="ms-2 text-white fs-6">
                Propertiesbyphone
              </Navbar.Brand>
            )}
          </div>

          <Navbar.Toggle aria-controls="navbar-nav" />
        </Container>
      </Navbar>
      <Container fluid className="bg-body-tertiary dark__bg-gray-1200 ">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{
            backgroundImage: `url(${'https://images.pexels.com/photos/1370704/pexels-photo-1370704.jpeg?cs=srgb&dl=pexels-jessica-bryant-592135-1370704.jpg&fm=jpg'})`
          }}
        />

        <Row className="flex-center position-relative min-vh-100 g-0 px-4 py-5">
          <Col xs={11} sm={10} xl={4}>
            <Card className="border border-translucent ">
              <Card.Body className="">
                <Row className="align-items-center gx-0 gy-7">
                  <Col className="mx-auto">
                    {logo && (
                      <div className="text-center">
                        <Link
                          to="/"
                          className="d-inline-block text-decoration-none mb-4 "
                        >
                          {/* <Logo
                          text={false}
                          width={150}
                          className="fw-bolder fs-5 d-inline-block"
                        /> */}
                        </Link>
                      </div>
                    )}
                    <div className="auth-form-box">{children}</div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AuthCardLayout;
